import { makeStyles } from '@material-ui/core'
import React, { useImperativeHandle, useState } from 'react'
import { wait } from '../../../../utils'

const useStyles = makeStyles(() => ({
    shaken: {
        animation: '$shake 0.7s',
        animationIterationCount: '1'
    },
    '@keyframes shake': {
        '0%': { transform: 'translateX(0)' },
        '15%': { transform: 'translateX(-4px)' },
        '30%': { transform: 'translateX(6px)' },
        '45%': { transform: 'translateX(-4px)' },
        '60%': { transform: 'translateX(6px)' },
        '75%': { transform: 'translateX(-4px)' },
        '90%': { transform: 'translateX(6px)' },
        '100%': { transform: 'translateX(0)' }
    }
}))

export const Shakeable = React.forwardRef((props, ref) => {
    const classes = useStyles()
    const [isShaken, setIsShaken] = useState(false)

    const shake = async () => {
        setIsShaken(true)
        await wait(1000)
        setIsShaken(false)
    }

    useImperativeHandle(
        ref,
        () => {
            return {
                shake
            }
        },
        []
    )

    return (
        <div className={isShaken ? classes.shaken : ''}>{props.children}</div>
    )
})
